<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.h6.basic800--text {{ $t('update_recipient_details') }}
      v-divider.basic300
      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4
            p.mb-3.label.basic600--text.text-uppercase {{ $t('recipient_name.label') }}
            v-text-field.p1(background-color="basic200" height="40" v-model="address.name" :placeholder="$t('recipient_name.placeholder')" outlined dense :rules="rules.not_empty")
            p.mb-3.label.basic600--text.text-uppercase {{ $t('recipient_phone.label') }}
            v-text-field.p1(background-color="basic200" height="40" v-model="address.phone" :placeholder="$t('recipient_phone.placeholder')" outlined dense :rules="rules.not_empty")
            address-inputs-id(v-if="isIndoAddress" :parentAddress.sync="address")
            address-inputs(v-else :parentAddress.sync="address" :autofillPostcode="false")
      v-card-actions
        v-spacer
        v-btn.button-AA-medium(color='grey', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          | {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
import AddressInputs from '@/components/AddressInputs.vue'
import AddressInputsId from '@/components/AddressInputsId.vue'

export default {
  name: 'EditRecipientDetails',
  props: ['open', 'parentLead'],
  components: { AddressInputs, AddressInputsId },
  data: () => ({
    address: {},
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isIndoAddress () {
      if (this.parentLead.shipping_address) {
        if (this.parentLead.shipping_address.area) {
          return true
        }
      } else if (this.$currency.code === 'IDR') {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.parentLead.shipping_address) {
      this.address = { ...this.parentLead.shipping_address }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = {
        shipping_address: this.address
      }
      this.axios.patch(`/leads/${this.lead.pid}/`, params)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.address_updated')])
          this.$set(this.lead, 'shipping_address', this.address)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "update_recipient_details": "Update recipient details",
    "recipient_name": {
      "label": "Recipient Name",
      "placeholder": "e.g. John Doe"
    },
    "recipient_phone": {
      "label": "Recipient Phone",
      "placeholder": "e.g. 0123456789"
    },
    "cancel": "Cancel",
    "update": "Update"
  },
  "id": {
    "update_recipient_details": "Perbarui Detail Penerima",
    "recipient_name": {
      "label": "Nama Penerima",
      "placeholder": "e.g. John Doe"
    },
    "recipient_phone": {
      "label": "Nomor HP penerima",
      "placeholder": "e.g. 0123456789"
    },
    "cancel": "Batal",
    "update": "Perbarui"
  }
}
</i18n>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

</style>
